"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const Card_1 = __importDefault(require("@mui/material/Card"));
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const Portal_1 = __importDefault(require("@mui/material/Portal"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const StyledCard = (0, styled_components_1.default)(Card_1.default) `
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;

  &.MuiPaper-rounded {
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
  }
`;
const StyledContent = styled_components_1.default.div `
  padding: 0;
`;
const CloseButtonContainer = styled_components_1.default.div `
  margin: 8px 8px 0 0;
`;
const PopupContainer = styled_components_1.default.div `
  position: fixed;
  bottom: 32px;
  right: 0;
  z-index: 10;
`;
const DesktopPrompt = ({ children, direction, handleClose, isPopupVisible, ...rest }) => {
    const theme = (0, styled_components_1.useTheme)();
    if (!direction && isPopupVisible) {
        return ((0, jsx_runtime_1.jsxs)(StyledCard, { ...rest, children: [(0, jsx_runtime_1.jsx)(StyledContent, { children: children }), (0, jsx_runtime_1.jsx)(CloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "close-button", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { color: theme.palette.text.primary, size: 24 }) }) })] }));
    }
    return ((0, jsx_runtime_1.jsx)(Portal_1.default, { children: (0, jsx_runtime_1.jsx)(Slide_1.default, { direction: direction, in: isPopupVisible, children: (0, jsx_runtime_1.jsx)(PopupContainer, { children: (0, jsx_runtime_1.jsxs)(StyledCard, { ...rest, children: [(0, jsx_runtime_1.jsx)(StyledContent, { children: children }), (0, jsx_runtime_1.jsx)(CloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "close-button", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { color: theme.palette.text.primary, size: 24 }) }) })] }) }) }) }));
};
exports.default = DesktopPrompt;
//# sourceMappingURL=index.js.map